import { Box, Flex, Text } from '@chakra-ui/react';
import useTranslation from 'next-translate/useTranslation';
import { useEffect, useRef, useState } from 'react';

export type ReviewCardBodyProps = {
  reviewText: string;
  limitHeight?: boolean;
  onExpand?: () => void;
};

export const ReviewCardBody = ({
  reviewText,
  onExpand,
  limitHeight = false,
}: ReviewCardBodyProps) => {
  const { t } = useTranslation('reviews');

  const contentRef = useRef<HTMLDivElement>(null);
  const [isClamped, setClamped] = useState(false);
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    setClamped(contentRef.current.scrollHeight > contentRef.current.clientHeight);
  }, []);

  const handleToggle = () => {
    onExpand && onExpand();
    setOpen(!isOpen);
  };

  return (
    <Flex gap="space.24" flexDirection="column" alignItems="flex-start">
      <Box>
        <Text
          ref={contentRef}
          size="md"
          textOverflow="ellipsis"
          overflow={'hidden'}
          noOfLines={!isOpen ? 5 : null}>
          {reviewText}
        </Text>
      </Box>
      {limitHeight && isClamped && (
        <Text as="button" color="lightPurple" cursor="pointer" onClick={handleToggle}>
          {!isOpen ? t('card.more-btn') : t('card.less-btn')}
        </Text>
      )}
    </Flex>
  );
};
